module.exports = __webpack_public_path__ + "img/free.208ede2c.png";